import { getFeatureEnabled, FeatureEnabledV2, Throttle, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';
import { RESET_FORM, Feature, COREX_AML_FILES_QUERY } from '@gig/magic-messages';
import '@gig/magic-sdk/dist/adapter/users/getAmlStatus';
import { getUploadFormConfig } from './form-config/upload-form.config.js';

var VerificationUploadFormComponent = /** @class */ (function (_super) {
    __extends(VerificationUploadFormComponent, _super);
    function VerificationUploadFormComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disableManualUpload = false;
        _this.formConfig = [];
        _this.files = [];
        _this.allowAllDocumentsUpload = false;
        _this.formKey = 0;
        return _this;
    }
    VerificationUploadFormComponent.prototype.created = function () {
        var _this = this;
        this.loadFilesAndInitializeFormConfig();
        window.eventBus.subscribe(RESET_FORM, function (event) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (event) {
                    this.resetForm();
                }
                return [2 /*return*/];
            });
        }); });
    };
    VerificationUploadFormComponent.prototype.loadFilesAndInitializeFormConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var allFiles, _a, _b, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.fetchUserDocuments()];
                    case 1:
                        allFiles = _c.sent();
                        this.files = allFiles.filter(function (file) { return file.verificationStatus === 'Requested'; });
                        _a = this;
                        return [4 /*yield*/, getFeatureEnabled(Feature.ALLOW_ALL_DOCUMENTS_UPLOAD)];
                    case 2:
                        _a.allowAllDocumentsUpload = _c.sent();
                        _b = this;
                        return [4 /*yield*/, getUploadFormConfig(this.documentType, this.files, this.allowAllDocumentsUpload)];
                    case 3:
                        _b.formConfig = _c.sent();
                        this.onFormUpdate({}, true);
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _c.sent();
                        console.error('Error loading files and initializing form config:', error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    VerificationUploadFormComponent.prototype.fetchUserDocuments = function () {
        return window.queryBus.query(COREX_AML_FILES_QUERY);
    };
    VerificationUploadFormComponent.prototype.onChange = function (event) {
        var form = event.detail[0].form;
        this.onFormUpdate(this.getFormValue(form), this.isFormInvalid(form));
    };
    VerificationUploadFormComponent.prototype.onFormUpdate = function (value, disabled) {
        return {
            value: value,
            disabled: disabled,
        };
    };
    VerificationUploadFormComponent.prototype.isFormInvalid = function (form) {
        var _this = this;
        return Object.values(form).some(function (field) { return _this.isInvalidField(field); });
    };
    VerificationUploadFormComponent.prototype.getFormValue = function (form) {
        var date = form['document-expiry'];
        var number = form['document-number'];
        return {
            Side: form['document-side'].value,
            Type: form['document-type'].value,
            DocumentNumber: this.isValidField(number) ? number.value : '',
            ExpiresOn: this.isValidField(date)
                ? new Date(date.value).toISOString()
                : '',
        };
    };
    VerificationUploadFormComponent.prototype.isInvalidField = function (field) {
        return !field.hidden && !field.isValid;
    };
    VerificationUploadFormComponent.prototype.isValidField = function (field) {
        return !field.hidden && field.isValid;
    };
    VerificationUploadFormComponent.prototype.resetForm = function () {
        this.formKey = Date.now();
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], VerificationUploadFormComponent.prototype, "documentType", void 0);
    __decorate([
        FeatureEnabledV2({ slug: Feature.DISABLE_MANUAL_UPLOAD }),
        __metadata("design:type", Object)
    ], VerificationUploadFormComponent.prototype, "disableManualUpload", void 0);
    __decorate([
        Throttle(500),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [CustomEvent]),
        __metadata("design:returntype", void 0)
    ], VerificationUploadFormComponent.prototype, "onChange", null);
    __decorate([
        Emit('form-update'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Boolean]),
        __metadata("design:returntype", void 0)
    ], VerificationUploadFormComponent.prototype, "onFormUpdate", null);
    VerificationUploadFormComponent = __decorate([
        Component({
            name: 'corex-verification-upload-form',
        })
    ], VerificationUploadFormComponent);
    return VerificationUploadFormComponent;
}(Mixins(MagicConfigMixin)));

export default VerificationUploadFormComponent;
